import React, { ReactNode, useContext, useMemo } from 'react';
import {
  LoginApi,
  LoginApiInterface,
  RegistreringApi,
  RegistreringApiInterface,
} from './generated/login-generated-api';
import { SessionContext } from './sessionExtension';

export interface LoginApiStore {
  loginApi: LoginApiInterface;
  registreringApi: RegistreringApiInterface;
}

export const LoginApiContext = React.createContext<{
  loginApi: LoginApiInterface;
  registreringApi: RegistreringApiInterface;
}>({
  loginApi: new LoginApi(() => {}),
  registreringApi: new RegistreringApi(() => {}),
});

export const LoginApiProvider: React.FC<
  React.PropsWithChildren<{ children: ReactNode }>
> = ({ children }) => {
  const { setKeepAlive } = useContext(SessionContext);

  const loginApiStore: LoginApiStore = useMemo(
    () => ({
      loginApi: new LoginApi(setKeepAlive),
      registreringApi: new RegistreringApi(setKeepAlive),
    }),
    [setKeepAlive],
  );

  return (
    <LoginApiContext.Provider value={loginApiStore}>
      {children}
    </LoginApiContext.Provider>
  );
};
